import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { CustomSortService } from "@commoncore/services/custom-sort.service";
import { GoogleAnalyticsEvents } from "@commoncore/services/ga-events-service";
import { JustifiedView } from "@commoncore/utils/JustifiedViewUtil";
import { MultiSelectLibrary } from "@commoncore/utils/MultiSelectUtil";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "@env-properties/environment";

export class InviteLinkImplementation {
    http:any;
    universalService:any;
    public globalService:any;
    localStorageSvc:any;
    static singleInstance= null;
    receiverFirstName:any="";
    receiverLastName:any="";
    inviterFirstName:any = "";
    inviterLastName:any = "";
    showViewAlbumScreen:boolean = false;
    showJoinAlbumScreen:boolean = false;
    invalidInvite:boolean = false;
    sessionStorageService: any;
    isEasyShareInvite:boolean = false;
    isEasyShareAlbum:any;
    albumFilesMetaData: any;
    customMetadata: any;
    customSort: any;
    JsView: any;
    easyShareAlbumDetails: any;
    multiSelect: any;
    googleAnalyticsService: any;
    constructor(globalService) {
      this.globalService=globalService;
      this.localStorageSvc = globalService.getLocalStorageSvcRef();
    }

    public static getInstance(globalService):InviteLinkImplementation{
		if(this.singleInstance == null){
			this.singleInstance = new InviteLinkImplementation(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
    }

    public setHandler(globalService) {
        this.http = globalService.getHttpClientRef();
        this.universalService=globalService.getUniversalServiceRef();
        this.localStorageSvc = globalService.getLocalStorageSvcRef();
        this.sessionStorageService = globalService.getSessionStorageSvcRef();
        this.customMetadata = globalService.getCustomMetadataServiceRef();
        this.customSort = new CustomSortService(this.universalService);
        this.JsView = new JustifiedView(this.universalService);
        this.multiSelect = MultiSelectLibrary.getInstance(globalService);
        this.googleAnalyticsService = globalService.getGoogleAnalyticsEventsvc();
    }

    fetchInviteDetails(url){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
          suc=>{
            self.inviterFirstName = suc["inviterFirstName"];
            self.inviterLastName = suc["inviterLastName"]
            self.fetchReceiverDetails(suc);
            resolve(suc)
          },err=>{
            console.log("error in fetching invite details impl::",err);
            var userData = self.localStorageSvc.getUserData(true);
            if(userData!=undefined && userData.jcEntInfo!=undefined && err["error"]["code"] == "BRSOM0160"  ){
              self.sessionStorageService.setShowToastAlbumEntUser(true);
              window.location.href = "/home";
            }else{
              self.checkErrorHandling(err);
              reject(err)
            }
          }
        )
      })
    }

    fetchPublicInviteDetails(url){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
          suc=>{
            self.easyShareAlbumDetails = suc;
            self.albumFilesMetaData = suc["files"]
            self.universalService.showLoader = false;
            resolve(suc)
          },err=>{
            console.log("error in fetching invite details impl::",err);
            self.checkErrorHandling(err);
            reject(err)
          }
        )
      })
    }


    fetchReceiverDetails(details){
      var userData = this.localStorageSvc.getUserData(true);
      details["receiverFirstName"] = userData["firstName"];
      details["receiverLastName"] = userData["lastName"];
    }

    acceptInvitationForAlbum(url){
      var self = this;
      let status = "";
      let reason = "";
      return new Promise(function(resolve,reject){
        self.http.put(url).subscribe(
          suc=>{
            suc["inviterFirstName"] = self.inviterFirstName;
            suc["inviterLastName"] = self.inviterLastName;
            self.universalService.currentAlbum = suc;
            self.fetchReceiverDetails(suc);
            status = "success";
            self.googleAnalyticsService.albumJoined(GoogleAnalyticsEvents.EASYSHARE_ALBUM_JOINED,self.isEasyShareAlbum,status,reason);
            resolve(suc)
          },err=>{
            console.log("error in joining invite details",err);
            self.universalService.showLoader = false;
            status = "failure",
            reason = err["error"]["error"];
            self.googleAnalyticsService.albumJoined(GoogleAnalyticsEvents.EASYSHARE_ALBUM_JOINED,self.isEasyShareAlbum,status,reason);
            reject(err)
          }
        )
      })
    }

    checkErrorHandling(err){
      this.universalService.showLoader = false;
      if(err["error"]["code"] == "BINVS0018" || err["error"]["code"] == "BINVS0014" || err["error"]["code"] == "BINVS0038" || err["error"]["code"] == "TEJRF0404" || err["error"]["code"] == "BINVS0040" || err["error"]["code"] == "BRSOM0426"){
        this.invalidInvite = true;
        this.universalService.invalidInvite = true;
        this.showJoinAlbumScreen = false;
        this.showViewAlbumScreen = false;
      }
    }

    pickRandomColor(event) {
        // event.target.src = 'https://static.jiocloud.com/web2.0/common/images/gradient.png';
        // event.target.src = 'assets/images/invite-bg.png';
        event.target.src = 'https://static.jiocloud.com/web2.0/common/images/invite-bg.png';
        $('.no_blur__content').css({'width':"100%"})
    }

    async fetchSingleAlbumObjectList(suc){
      var self = this;
      var albumFilesMetaData = [];
      self.universalService.mobileSelectedObj = [];
      suc = suc["files"]?suc["files"]:suc

      self.albumFilesMetaData = self.customSort.sortListViewFilesByAttribute(suc, 'Descending', 'lastModifiedDate');
      self.albumFilesMetaData.forEach(obj=>{
        if(obj.mimeType == 'video'){
          obj.mimeType = 'image';
          obj.actualMimeType ='video'
        }
      })
      albumFilesMetaData = self.customMetadata.segregateData(self.albumFilesMetaData,'allfiles');

      await self.checkIfJustifiedLayout();
      if(self.universalService.showJustifiedLayout){
        if(albumFilesMetaData.length == 0) {
          self.albumFilesMetaData = albumFilesMetaData;
        } else {
          var justfiedViewFormat = await self.generateJustifiedView("#allFilesWrapperId",albumFilesMetaData);
          self.albumFilesMetaData = justfiedViewFormat;
        }
      }else{
        var checkIfLastViewIsJustfied = albumFilesMetaData.find(obj=> (obj["imageTranscodeUrl"] != undefined && obj["imageTranscodeUrl"].includes("size=v")));
        if(checkIfLastViewIsJustfied){ // this check is added when album is in justified view, and user upload a file type that is not supported for justfied view, eg: videos, then we need to set the size of the image to d as per grid view
          albumFilesMetaData.map(obj=>{
            obj["imageTranscodeUrl"] = obj["imageTranscodeUrl"].replace("size=v","size=c");
          })
        }
        self.albumFilesMetaData = albumFilesMetaData;
      }
      self.albumFilesMetaData.forEach(obj => {
        let type = self.universalService.checkIfImgTypeParamIsRequired(obj["mimeSubType"]);
        console.log("GIF"+obj["mimeSubType"]+">>>>"+type)
        obj["imageTranscodeUrl"] = obj["imageTranscodeUrl"] + '&appSecret=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"]+type;
      });
      AppEvents.virtualDOMObservable.next({"updateVDOM":true,"forceRefresh":true})
      self.bindMultiSelect("#allFilesWrapperId");
      self.checkPreviwTextStatus()
      // setTimeout(() => {
      //   this.setHeightForAlbumContents();
      // }, 600);
  }
  checkPreviwTextStatus(){
    if(this.albumFilesMetaData.length == this.easyShareAlbumDetails.filesCount){
      this.universalService.showBoardPreviewStrip = false;
    }else if(this.albumFilesMetaData.length < this.easyShareAlbumDetails.filesCount){
      this.universalService.showBoardPreviewStrip = true;
    }
  }

  bindMultiSelect(element){
    setTimeout(() => { // this is added because the element is not being renedered on the DOM in some scenarios
      this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
      this.multiSelect.bindMultiSelectLibrary(element, "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
      this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");
      AppEvents.multiSelectEvent.next({"dataArray":this.albumFilesMetaData})
    }, 100);
  }

  checkIfJustifiedLayout(){
    if(this.easyShareAlbumDetails["imageCount"] > 0 && this.easyShareAlbumDetails["videoCount"] == 0){
      this.universalService.showJustifiedLayout = true
    }else{
      this.universalService.showJustifiedLayout = false;
    }
  }

  generateJustifiedView(id,objects){
    var data = [];
    if(objects[0]["objects"]){
      data  = objects
    }else{
      data  = [{
        "objects":objects
      }]
    }
    var justifiedView = this.JsView.generateJustifiedView(data, id, this.universalService.rowHeightTolerance);
    return justifiedView[0]["objects"];
  }

}